<template>
    <div>
        <section id="Prix" class="pricing-section ptb-100 gray-light-bg">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-9 col-lg-8">
                        <div class="section-heading">
                            <h2 style="color: #313A58;">Nos forfaits</h2>
                            <h4 style="color: #313A58;">FDSU Docs vous offre, selon le profil de votre entreprise, des prix adaptés à votre
                            portefeuille </h4>
                            <p>
                                Otenez une licence <b>FDSU Docs</b> unique qui maximise les avantages que vous recevez, en vous garantissant une solution adaptée à vos
                                besoins et à vos exigences en matière de fonctionnalités.
                            </p>
                            <p class="card bg-light p-4">
                                Lorsque vous nous contactez, nos ingénieurs en solutions et nos chargés de la clientèle vous aident à trouver la solution
                                qui apporte le plus de valeur ajoutée à votre entreprise.
                            </p>
                            <a href="/register" class="btn btn-brand-03 animated-btn">
                                Contactez-nous
                            </a>
                        </div>
                    </div>
                </div>
                <!-- <div class="row align-items-center justify-content-md-center justify-content-center d-md-none">
                    <div class="col-lg-4 col-md-6 col-sm-8">
                        <div class="popular-price bg-white pricing-new-wrapper mt-4 p-5 shadow-sm border">
                            <div class="pricing-price d-flex justify-content-between align-items-center pb-4">
                                <span class="p-icon"><i class="fas fa-user color-secondary"></i></span>
                            </div>
                            <div class="pricing-info">
                                <h5>Nombre d'utilisateurs</h5>
                            </div>
                            <div class="pricing-content">
                                <ul class="list-unstyled pricing-feature-list-2 mt-4">
                                    <li>
                                        <p><strong>Jusqu'à 10</strong> pour 12.5$ par mois, par utilisateur</p>
                                    </li>
                                    <li>
                                        <p><strong>Jusqu'à 100</strong> pour 20$ par mois, par utilisateur</p>
                                    </li>
                                    <li>
                                        <p><strong>Plus de 100</strong> pour 40$ par mois, par utilisateur</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-8">
                        <div class="popular-price bg-white pricing-new-wrapper mt-4 p-5 shadow-sm border">
                            <div class="pricing-price d-flex justify-content-between align-items-center pb-4">
                                <span class="p-icon"><i class="fas fa-hdd color-secondary"></i></span>
                            </div>
                            <div class="pricing-info">
                                <h5>Stockage</h5>
                            </div>
                            <div class="pricing-content">
                                <ul class="list-unstyled pricing-feature-list-2 mt-4">
                                    <li>
                                        <p><strong>100 Go</strong> pour 15$ par mois</p>
                                    </li>
                                    <li>
                                        <p><strong>500 Go</strong> pour 20$ par mois</p>
                                    </li>
                                    <li>
                                        <p><strong>1 To</strong> pour 25$ par mois</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row d-md-block d-none">
                    <div class="col-md-12 col-lg-12">
                        <div class="table-responsive">
                            <table class="table w-100 table-hover table-bordered comparision-table text-center mb-4">
                                <thead class="comparision-table-head">
                                    <tr class="active">
                                        <th class="text-left">

                                        </th>
                                        <th><strong class="h5 mb-0">Standard</strong>
                                        </th>
                                        <th><strong class="h5 mb-0">Advanced</strong>
                                        </th>
                                        <th><strong class="h5 mb-0">Enterprise</strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="comparision-table-body">
                                    <tr>
                                        <td>
                                            <p class="mb-0 comparision-price-title text-left"><strong></strong></p>
                                        </td>
                                        <td class="py-4">
                                            <h4 class="mb-0 comparision-price">$15 <span>Par Mois</span></h4>
                                        </td>
                                        <td class="py-4">
                                            <h4 class="mb-0 comparision-price">$20 <span>Par Mois</span></h4>
                                        </td>
                                        <td class="py-4">
                                            <h4 class="mb-0 comparision-price">$25 <span>Par Mois</span></h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p class="text-left font-weight-bold">Stockage</p>
                                        </td>
                                        <td>100Go</td>
                                        <td>500Go</td>
                                        <td>1To</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table w-100 table-hover table-bordered comparision-table text-center mt-4">
                                <thead class="comparision-table-head">
                                    <tr class="active">
                                        <th class="text-left">

                                        </th>
                                        <th><strong class="h5 mb-0">Standard</strong>
                                        </th>
                                        <th><strong class="h5 mb-0">Advanced</strong>
                                        </th>
                                        <th><strong class="h5 mb-0">Enterprise</strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="comparision-table-body">
                                    <tr>
                                        <td>
                                            <p class="mb-0 comparision-price-title text-left"><strong></strong></p>
                                        </td>
                                        <td class="py-4">
                                            <h4 class="mb-0 comparision-price">$12.5 <span>Par Mois, par
                                                    utilisateur</span></h4>
                                        </td>
                                        <td class="py-4">
                                            <h4 class="mb-0 comparision-price">$20 <span>Par Mois, par
                                                    utilisateur</span></h4>
                                        </td>
                                        <td class="py-4">
                                            <h4 class="mb-0 comparision-price">$40 <span>Par Mois, par
                                                    utilisateur</span></h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p class="text-left font-weight-bold">Nombre d'utilisateurs</p>
                                        </td>
                                        <td>Jusqu'à 10</td>
                                        <td>Jusqu'à 100</td>
                                        <td>Plus de 100</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> -->

            <!-- <div class="row justify-content-center mt-4">
                <div class="col-md-9 col-lg-8 mt-4">
                    <div class="section-heading text-center mb-4">
                        <h3 style="color: #313A58;">Simulateur des prix</h3>
                        <p>
                            Entrez le les informations sur votre équipe pour avoir un aperçu du prix mensuel de dinflow
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body row">
                            <b-form class="col-md-6">
                                <div class="mt-2">
                                    <label class="mb-1" for="nb_user">Nombre d'utilisateurs</label>
                                    <b-form-input class="form-control" v-model="nb_user" id="nb_user" type="number"></b-form-input>
                                </div>
                                
                                <div class="mt-3">
                                    <label class="mb-1" for="nb_user">Stockage</label>
                                    <b-input-group class="mb-2 mr-sm-3">
                                        <b-form-select v-model="stockage"
                                        id="formrow-inputState"
                                        type="text"
                                        >
                                            <option v-for="option in options" :value="option.value" :key="option.id">
                                                {{ option.text }}
                                            </option>
                                        </b-form-select>
                                    </b-input-group>
                                </div>
                                <a class="btn btn-brand-03 animated-btn mt-4" href="#" target="_blank">Souscrire</a>
                            </b-form>
                            <div class="col-md-6 pb-2">
                                <p class="text-center mt-4">Prix</p>
                                <h1 class="text-center">{{price}} $ / mois</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  -->
            </div>
        </section>
        <!--footer section start-->
        <footer class="ooter-1 ptb-60 gradient-bg">
            <div class="container">
                <div class="row">
                    <!-- <div class="col-sm-6 col-md-3 col-lg-3"></div> -->

                    <div class="col-md-12 col-lg-6 mb-4 mb-md-4 mb-sm-4 mb-lg-0 pr-4">
                        <a href="#" class="navbar-brand mb-2">
                            <img src="@/assets/images/logo_2.svg" width="150" alt="logo" class="img-fluid">
                        </a>
                        <br>
                        <p class="text-white">FDSU Docs est une plateforme sécurisée, ultra-intuitive, de gestion de contenu, de partage de documents, de collaboration
                        et automatisation de vos processus métiers.</p>
                        <p class="text-muted">&copy; 2022, FDSU Docs cloud</p>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                        <h6 class="font-weight-normal text-white">Coordonnées</h6>
                        <ul>
                            <li class="text-white">
                                <i class="ti-world"></i> R.D. Congo
                            </li>
                            <li class="text-white">
                                <i class="ti-location-arrow"></i> Av. Ruwe Coin Kabalo 46, Lubumbashi
                            </li>
                            <li class="text-white">
                                <i class="ti-email"></i> info@dinflow.com
                            </li>
                            <li class="text-white">
                                <i class="ti-email"></i> +243 82 9811 700
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                        <h6 class="font-weight-normal text-white">Suivez-nous sur:</h6>
                        <ul class="list-inline social-list-default background-color social-hover-2 mt-2">
                            <li class="list-inline-item"><a class="facebook"
                                    href="https://web.facebook.com/dintechnologyrdc"><i class="fab fa-facebook"></i></a>
                            </li>
                            <li class="list-inline-item"><a class="instagram"
                                    href="https://www.linkedin.com/company/din-technology/"><i
                                        class="fab fa-instagram"></i></a></li>
                            <li class="list-inline-item">
                                <a class="linkedin"
                                target="_blank"
                                    href="https://www.linkedin.com/company/dinflow/">
                                    <i class="fab fa-linkedin-in"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!--end of container-->
        </footer>
    </div>
</template>
<script>
export default {
    data(){
        return{
            stockage: 0,
            nb_user: 0,
            options:[
                {value: 15, text: '100 Go'},
                {value: 20, text: '500 Go'},
                {value: 25, text: '1 To'}
            ]
        }
    },
    computed: {
        price(){
            var price_nb_user = this.nb_user<=10 ? 12.5 : 
                                this.nb_user<=100 ? 20 :
                                40;
            var p = parseInt(this.stockage) + price_nb_user * parseInt(this.nb_user);
            return isNaN(p) ? '*' : p;
        }
    }
}
</script>
<style>
.form-control {
  border: 1px solid #ced4da;
  background-color: transparent;
  border-radius: 4px;
}
</style>